import styled from 'styled-components';

export const EndGameButtonWrap = styled.span`
  display: flex;
  flex: 1;
  opacity: 0;
  transform: rotateX(180deg) skew(20deg) translate(0, 10px);
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut};
  transition-delay: 0.7s;

  .end-game-options-enter-done & {
    opacity: 1;
    transform: rotateX(0) skew(0) translate(0, 0);
  }
`;

export const Text = styled.span`
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    display: inline-block;
  }
`;

const EndGameButtonStyled = styled.button`
  align-items: center;
  background: ${props => props.theme.colors.quaternary};
  border: 1px solid #0ad97d;
  color: ${props => props.theme.colors.tertiary};
  cursor: pointer;
  display: flex;
  font-family: ${props => props.theme.fonts.primary};
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.2vmin);
  font-weight: 700;
  justify-content: center;
  margin: 0;
  outline: 0;
  padding: 5px;
  text-align: center;
  transition: box-shadow ${props => props.theme.transition.duration}
    ${props => props.theme.transition.easeOut};
  width: 100%;

  &:hover,
  &:focus {
    box-shadow: inset 0 5px 0 rgba(0, 0, 0, 0.07);
  }

  &:active {
    box-shadow: inset 0 8px 0 rgba(0, 0, 0, 0.07);
    transform: translateY(2px);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 5px 30px 5px 20px;
  }
`;

export default EndGameButtonStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/EndGameButton/EndGameButton.styled.js